import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getLocation,
  getIdLocation,
  createLocation,
  updateLocation,
  deleteLocation,
  getLocationMaster,
} from "./locationManagementAPI";
import createTransform from "redux-persist/es/createTransform";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchLocation = createAsyncThunk(
  "Location/fetchLocation",
  async (payload) => {
    const response = await getLocation(payload);
    return response;
  }
);
export const fetchLocationMaster = createAsyncThunk(
  "Location/fetchLocationMaster",
  async (payload) => {
    const response = await getLocationMaster(payload);
    return response;
  }
);
export const fetchIdLocation = createAsyncThunk(
  "Location/fetchIdParameter",
  async (id) => {
    const response = await getIdLocation(id);
    return response;
  }
);
export const addLocation = createAsyncThunk(
  "Location/addLocation",
  async (payload) => {
    const response = await createLocation(payload);
    return response;
  }
);

export const editLocation = createAsyncThunk(
  "Location/editLocation",
  async (payload) => {
    const response = await updateLocation(payload);
    return response;
  }
);

export const removeLocation = createAsyncThunk(
  "Location/removeById",
  async (payload) => {
    const response = await deleteLocation(payload);
    return response;
  }
);

export const locationManagementSlice = createSlice({
  name: "locationManagement",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(editLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = locationManagementSlice.actions;

export const selectLocation = (state) => state.locationManagement.data;
export const selectIdLocation = (state) => state.locationManagement.dataId;
export const selectLoading = (state) => state.locationManagement.loading;
export const selectError = (state) => state.locationManagement.error;
export const selectPageNo = (state) => state.locationManagement.pageNo;
export const selectPageSize = (state) => state.locationManagement.pageSize;
export const selectTotalRecord = (state) =>
  state.locationManagement.totalRecord;
export const selectSelected = (state) => state.locationManagement.selected;
export const selectResult = (state) => state.locationManagement.result;

export default locationManagementSlice.reducer;
